import apiCaller from "../../../helper/apiCall";
import { APPROVER_ENDPOINTS } from "../../urls/endpoints";

const fetchApproverDashboardCards = async (params = {}) => {
  const response = await apiCaller(
    APPROVER_ENDPOINTS.DASHBOARD_CARDS,
    "GET",
    params
  );
  return response;
};

const fetchApproverFarmerList = async (params) => {
  const dataToSend = {
    type: params.type || "asc",
    currentPage: params.currentPage || 1,
    search: params.search || "",
    searchCol: params.searchCol || "",
    sortCol: params.sortCol || "",
    programCode: params.programCode || "APPROVER",
    filters: params.filters || {},
    ...params,
  };

  const response = await apiCaller(
    APPROVER_ENDPOINTS.FARMER_LIST,
    "POST",
    dataToSend
  );
  return response;
};

const fetchApproverFarmerDetails = async (farmerId) => {
  const response = await apiCaller(APPROVER_ENDPOINTS.FARMER_DETAILS, "POST", {
    farmerId,
  });
  return response;
};

const verifyFarmer = async (data) => {
  const response = await apiCaller(
    APPROVER_ENDPOINTS.VERIFY_FARMER,
    "POST",
    data
  );
  return response;
};

const revertFarmer = async (data) => {
  const response = await apiCaller(
    APPROVER_ENDPOINTS.REVERT_FARMER,
    "PUT",
    data
  );
  return response;
};

const fetchApproverProfile = async (data) => {
  const response = await apiCaller(
    APPROVER_ENDPOINTS.VIEW_PROFILE,
    "POST",
    data
  );
  return response;
};

const updateApproverProfile = async (data) => {
  const response = await apiCaller(
    APPROVER_ENDPOINTS.UPDATE_PROFILE,
    "PUT",
    data
  );
  return response;
};

const exportApproverFarmers = async (params) => {
  const dataToSend = {
    ...params,
    exportFlag: true,
  };

  const response = await apiCaller(
    APPROVER_ENDPOINTS.EXPORT_FARMERS,
    "POST",
    dataToSend
  );

  if (response?.status === "success" && response?.data) {
    const aLink = document.createElement("a");
    aLink.href = response.data;
    aLink.click();
  }

  return response;
};

export {
  fetchApproverDashboardCards,
  fetchApproverFarmerList,
  fetchApproverFarmerDetails,
  verifyFarmer,
  revertFarmer,
  fetchApproverProfile,
  updateApproverProfile,
  exportApproverFarmers,
};
